import { Icon } from '@oneaudi/unified-web-components';
import * as React from 'react';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  transition: transform 200ms ${(props) => props.theme.easing};
  margin-inline-start: var(--spacing-relative-sm);
  transform: rotateZ(0deg);

  &.rotated-90 {
    transform: rotateZ(90deg);
  }

  &.rotated-180 {
    transform: rotateZ(-180deg);
  }

  ${({ theme }) =>
    theme.type !== 'legacy' &&
    `
      color: ${theme.cmp.color.navigation.textLink.foreground.default};
    `}
`;

export interface ArrowIconProps {
  readonly rotated: boolean;
}

export const ArrowIcon: React.FC<ArrowIconProps> = ({ rotated }) => (
  <StyledIcon name="arrow-down" size="s" className={rotated ? `rotated-180` : ''} />
);
